import React, { useEffect, useState } from "react";
import { BACKEND_URL } from "../../../config";

function AdminContact() {

  const [contacts, setContacts] = useState([]);
  const [expandedIds, setExpandedIds] = useState([]); // NAYA: show more/less track karne ke liye

  const loadContacts = async () => {

    const res = await fetch(
      `${BACKEND_URL}/api.php?module=contact`
    );

    const data = await res.json();

    if (data.success) {
      setContacts(data.data);
    }
  };

  const deleteContact = async (id) => {

  if (!window.confirm("Delete this message?")) {
    return;
  }

  try {

    const fd = new FormData();
    fd.append("action", "delete");
    fd.append("id", id);

    const res = await fetch(
      `${BACKEND_URL}/api.php?module=contact`,
      {
        method: "POST",
        body: fd
      }
    );

    const data = await res.json();

    if (data.success) {
      loadContacts();
    } else {
      alert(data.message);
    }

  } catch {
    alert("Delete failed");
  }
};

  useEffect(() => {
    loadContacts();
  }, []);

  // NAYA: message expand/collapse toggle
  const toggleExpand = (id) => {
    setExpandedIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  // NAYA: lambe message ko truncate karke "Show more/less" dena
  const renderMessage = (item) => {
    const message = item.message || "";
    const isLong = message.length > 120;
    const isExpanded = expandedIds.includes(item.id);

    if (!isLong) return message;

    return (
      <>
        {isExpanded ? message : message.slice(0, 120) + "..."}
        <span className="show-toggle" onClick={() => toggleExpand(item.id)}>
          {isExpanded ? " Show less" : " Show more"}
        </span>
      </>
    );
  };

  return (

    <div className="admin-page">

      <h2>Contact Messages</h2>

      {/* NAYA: "contact-table" class add ki - sirf isi table ke liye CSS override lagega */}
      <div className="admin-table contact-table">

        <table>

          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Message</th>
              <th>Date</th>
              <th>Action</th>

            </tr>
          </thead>

          <tbody>

            {contacts.map(item => (

              <tr key={item.id}>

                <td>
                  {item.firstName}
                  {" "}
                  {item.lastName}
                </td>

                <td>{item.email}</td>

                <td>{item.phone}</td>

                {/* CHANGE: item.message ki jagah renderMessage(item) aur message-cell class */}
                <td className="message-cell">{renderMessage(item)}</td>

                <td>
                  {new Date(
                    item.createdAt
                  ).toLocaleDateString()}
                </td>

                <td className="action-btns">

                  <button
                    className="admin-btn delete"
                    onClick={() => deleteContact(item.id)}
                  >
                    Delete
                  </button>

                </td>
              </tr>

            ))}

          </tbody>

        </table>

      </div>

    </div>

  );
}

export default AdminContact;
